import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vaLittle from './valittle'
Vue.use(vaLittle);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
